import { useTranslation } from 'react-i18next';
import { KoobPageHeader } from '@koob/ui';
import ToConnectionRequestBulkEdit from '../BulkEdit';
import ToConnectionRequestModels from '../Models';
import ToConnectionRequestPromotions from '../Promotions';

const TABS = {
  bulkEdit: ToConnectionRequestBulkEdit,
  models: ToConnectionRequestModels,
  promotions: ToConnectionRequestPromotions,
};

// Bulk edit, distribution models and promotions: the distribution tools that
// act on many connections at once, one URL each.
const BulkEditTabs = ({ tab }) => {
  const { t } = useTranslation('toConnectionRequest');
  const Content = TABS[tab];

  return (
    <>
      <KoobPageHeader
        title={t('pages:distribution')}
        tabs={[
          {
            label: t('bulkEditTabs.bulkEdit'),
            to: '/to-connection-request/bulk-edit',
          },
          {
            label: t('bulkEditTabs.DistributionModels'),
            to: '/to-connection-request/models',
          },
          {
            label: t('bulkEditTabs.promotions'),
            to: '/to-connection-request/promotions',
          },
        ]}
      />
      <Content />
    </>
  );
};

export default BulkEditTabs;
